import { render } from "./AgeVerificationModal.vue?vue&type=template&id=6a7e2932&scoped=true"
import script from "./AgeVerificationModal.vue?vue&type=script&lang=js"
export * from "./AgeVerificationModal.vue?vue&type=script&lang=js"

import "./AgeVerificationModal.vue?vue&type=style&index=0&id=6a7e2932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7e2932"]])

export default __exports__